import React from "react";
import Typography from "@material-ui/core/Typography";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { ValmetGrey4 } from "theme";

const localStyles = makeStyles((theme: Theme) =>
  createStyles({
    frameTitle: {
      marginBottom: "20px",
      textAlign: "left",
      color: ValmetGrey4,
      [theme.breakpoints.down("sm")]: {
        fontSize: "15px",
      },
    },
  }),
);

interface Props {
  title: string;
}

const ContentFrame: React.FC<Props> = ({ title, children }) => {
  const localClasses = localStyles();

  return (
    <div>
      <header>
        <Typography variant="h2" className={localClasses.frameTitle}>
          {title}
        </Typography>
      </header>
      {children}
    </div>
  );
};

export default ContentFrame;
